import styled from 'styled-components';
import { Row, Col, Button } from 'antd';

interface ProgressPartProps {
	percentage: number;
}

export const Content = styled(Row)`
	margin-left: 12px;
`;

export const InformationsContainer = styled.div`
	width: 100%;
	display: flex;
	border-radius: 10px;
	border: 1px solid #e8e8e8;
	justify-content: space-around;
`;

export const InformationInnerLeftContainer = styled.div`
	width: 15%;
	padding: 20px;
	display: flex;
	text-align: left;
	align-items: center;
	justify-content: center;
	background-color: #f8f8f8;
`;

export const InformationInnerRightContainer = styled.div`
	display: flex;
	justify-content: left;
	align-items: left;
	padding: 20px;
	width: 85%;

	p {
		margin: 0;
		font-size: 1.1rem;
	}
`;

export const StyledButton = styled(Button)`
	border: none !important;
	background: none !important;
	box-shadow: none !important;
	color: inherit !important;
	padding: 0 !important;

	&:hover,
	&:focus,
	&:active,
	&:focus-visible {
		color: inherit !important;
		border: none !important;
		background: none !important;
		box-shadow: none !important;
		outline: none !important;
	}

	.ant-btn-wave::after {
		display: none !important;
	}

	&::after {
		display: none !important;
	}
`;

export const FrequencyLabel = styled.div`
	border: 2px solid #2f54eb;
	padding: 0.5rem 1rem;
	border-radius: 6px;
	background-color: #2f54eb0d;

	span {
		font-size: 1.1rem;
		font-weight: 500;
		color: #2f54eb;

		strong {
			font-weight: 600;
		}
	}
`;

export const StyledPercentageDiv = styled.div`
	width: 100% !important;
	background-color: #e0e0e0 !important;
	height: 35px !important;
	border-radius: 10px !important;
	overflow: hidden !important;
	position: relative !important;
	display: flex !important;

	font-weight: 600;
	font-size: 1rem;
`;

const ProgressPart = styled.div<ProgressPartProps>`
	height: 100%;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #fff;
	width: ${({ percentage }) => percentage}%;

	strong {
		font-size: 1rem;
	}
`;

export const CategoryOne = styled(ProgressPart)`
	background-color: #2cc852;
`;

export const CategoryTwo = styled(ProgressPart)`
	background-color: #f8d627;
`;

export const CategoryThree = styled(ProgressPart)`
	background-color: #e74150;
`;

export const CategoryFour = styled(ProgressPart)`
	background-color: #9b54e2;
`;

export const StyledDivInformations = styled.div`
	width: 100% !important;
	height: 100% !important;
	border-radius: 10px !important;
	margin-top: 3rem;
`;

export const StyledColHeader = styled(Col)`
	background-color: #f8f8f8 !important;
	border-right: 1px solid #e6e8e8;
	display: flex;
	justify-content: center;
	align-items: center;
	color: black;
	padding: 1rem;

	:last-child {
		border-right: none;
	}

	&.border-left {
		border-top-left-radius: 10px !important;
	}

	&.border-right {
		border-top-right-radius: 10px !important;
	}
`;

export const StyledLineRow = styled(Row)`
	border: 1px solid #e6e8e8;

	:last-child {
		border-bottom-left-radius: 10px !important;
		border-bottom-right-radius: 10px !important;
	}
`;

export const StyledLineCol = styled(Col)`
	height: 100%;
	padding: 1rem;
	border-right: 1px solid #e6e8e8;
	justify-content: center;
	align-items: center;
	display: flex;
`;

export const CategorySquare = styled.div`
	width: 75px;
	height: 50px;
	border-radius: 6px;
	background-color: ${({ color }) => color};
	justify-content: center;
	align-items: center;
	display: flex;
	span {
		color: #fff;
		font-size: 1rem;
		font-weight: bold;
	}
`;

export const CategoryContainer = styled.div`
	display: flex;
	align-items: center;
	height: 30px;

	.ant-typography {
		font-size: 1.1rem;
	}
`;

export const ColorSquare = styled.div<{ color: string }>`
	width: 22px;
	height: 22px;
	border-radius: 6px;
	background-color: ${({ color }) => color};
	margin-right: 25px;
`;

export const VerticalStyledCol = styled(Col)`
	display: inline-flex;
	align-self: stretch;
	align-items: center;
	flex-direction: column;
	border: 1px solid #e6e8e8;
`;

export const StyledScoreRow = styled(Row)`
	width: 55%;
	display: flex;
	justify-content: space-between;
	border: 1px solid #e6e8e8;
	margin-top: 0.5rem;
	border-radius: 6px;
	height: 48px;

	:first-child {
		margin-top: 1rem;
	}

	:last-child {
		margin-bottom: 1rem;
	}
`;

export const StyledScorColCode = styled(Col)`
	width: 60%;
	display: flex;
	text-align: center;
	justify-content: center;
	align-items: center;
	font-size: 1rem;
`;

export const StyledScorColFrequency = styled(Col)`
	width: 40%;
	display: flex;
	text-align: center;
	justify-content: center;
	align-items: center;
	background-color: #f8f8f8;
	font-size: 1rem;
`;

export const StyledRiskDiv = styled.div`
	margin-top: 2rem;
	margin-bottom: 3rem;
	width: 100% !important;
`;

export const StyledDivRiskSegment = styled.div`
	background-color: #f8f8f8;
	width: 100%;
	padding: 1.5rem;
	border-radius: 12px;
	margin-top: 2rem;
`;

export const StyledRowRiskType = styled(Row)`
	background-color: #fff;
	width: 100%;
	border-bottom: 1px solid #e8e8e8;

	:first-child {
		border-top-right-radius: 12px;
		border-top-left-radius: 12px;
	}

	:last-child {
		border-bottom-right-radius: 12px;
		border-bottom-left-radius: 12px;
	}
`;

export const StyledColRiskTypeName = styled(Col)`
	width: 90%;
	display: flex;
	justify-content: left;
	padding: 0.8rem;
	padding-left: 1.5rem;
`;

export const StyledColRiskTypePercentage = styled(Col)`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 10%;
`;

export const RiskSquare = styled.div`
	margin-right: 20px;
	width: 75px;
	height: 40px;
	border-radius: 6px;
	background-color: ${({ color }) => color};

	justify-content: center;
	align-items: center;
	display: flex;

	span {
		font-size: 1rem;
		font-weight: bold;
	}

	.color-1 {
		color: #d9d9d9;
	}

	.color-2 {
		color: #fff;
	}

	&.border-gray {
		border: 2px solid #e6e8e8;
	}
`;
